export const fills = {
  default: "#edecea",
  contrast: "#e8e8e8"
};
